import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FiThreeColumnsComponent } from './fi-three-columns-container.component';

@NgModule({
    imports: [CommonModule, ScrollingModule],
    declarations: [FiThreeColumnsComponent],
    exports: [FiThreeColumnsComponent],
})
export class FiThreeColumnsContainerModule {}
